import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rbtpks7s3j: FaireBrandEntity = {
  token: "b_rbtpks7s3j",
  type: "brand",
  name: "Whispering Wellness Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/f2b26448efe2922993e7230c748c3c71e38767bf05728fa84f73082a92e52166.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b3436698bebb6baa3e254671b72fa4be1c95244d7d7ae90b505f7f71a72de7f8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f2b26448efe2922993e7230c748c3c71e38767bf05728fa84f73082a92e52166.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b3436698bebb6baa3e254671b72fa4be1c95244d7d7ae90b505f7f71a72de7f8.png",
  location: "Boring, OR, USA",
  minimumOrderDollars: 50,
  rating: 4.6,
  reviewCount: 16,
  isInsider: true,
  description:
    "Whispering Wellness Co. was born out of a personal journey to reclaim health through natural remedies. After battling a hormonal imbalance that left me struggling with weight, high cortisol, and stress, I found relief through holistic wellness and discovered the transformative power of magnesium. My flagship product, Magnesium Mist, became a staple in my own routine, helping to bring calm, balance, and support to my body. When I shared it with my social media followers, the response was overwhelming—people across the U.S. loved the mist and the wellness journey it represented.\n\nToday, Whispering Wellness Co. continues to focus on natural, body-supportive supplements designed to empower others on their paths to health.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:24.794Z",
    importedBy: "entity-db-cli",
  },
};
